import { createFileRoute, Outlet } from "@tanstack/react-router";

import { Authenticated } from "~/components/Authenticated";

export const Route = createFileRoute("/_authenticated")({
  component: AuthenticatedRoute,
});

function AuthenticatedRoute() {
  return (
    <Authenticated>
      <Outlet />
    </Authenticated>
  );
}
